import React from "react";
import Spacing from "../Spacing";
import SectionHeadingStyle3 from "../SectionHeading/SectionHeadingStyle3";
import { pageTitle } from "../../helpers/PageTitle";
import { Icon } from "@iconify/react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import useFunctions from "../../Hooks/useFunctions";

export default function ContactPage() {
  pageTitle("Contact");
  const { phone, setPhone, handleChange, sendEmail } = useFunctions();
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Get in touch for more <br/>information and support"
        subTitle="Contact"
        shape="shape_6"
      />
      <Spacing lg="75" md="60" />
      <section>
        <div className="container">
          <div className="row align-items-center cs_gap_y_45">
            {/* <div className="col-lg-6">
              <h2 className="cs_fs_50">
                Come & visit <br />
                our place!
              </h2>
              <div className="cs_height_55 cs_height_lg_30" />
              <ul className="cs_mp0 cs_contact_info">
                <li>
                  <h3 className="cs_fs_29 cs_semibold">Email:</h3>
                  <p className="mb-0">hello@zivan.com</p>
                </li>
                <li>
                  <h3 className="cs_fs_29 cs_semibold">Phone:</h3>
                  <p className="mb-0">+54 45 454 78 23</p>
                </li>
                <li>
                  <h3 className="cs_fs_29 cs_semibold">Address:</h3>
                  <p className="mb-0">55/53 Jay Pathshala Apt. 908, USA</p>
                </li>
              </ul>
            </div> */}
            <div className="col-xl-12 col-lg-12">
              <div className="cs_contact_form_wrap">
                <div className=" cs_contact_form_bg" />




                <form className="cs_contact_form" onSubmit={sendEmail}>
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Your full name
                  </label>
                  <input
                    placeholder="Type your name"
                    type="text"
                    name="name"
                    className="cs_form_field"
                    style={{
                      border: "1px solid #fd6219",
                      borderRadius: "10px"
                    }}
                    required
                    onChange={handleChange}
                  />

                  <div className="cs_height_38 cs_height_lg_25" />

                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Give valid email
                  </label>
                  <input
                    placeholder="Type your email address"
                    type="email"
                    name="email"
                    className="cs_form_field"
                    style={{
                      border: "1px solid #fd6219",
                      borderRadius: "10px"
                    }}
                    required
                    onChange={handleChange}
                  />
                  <div className="cs_height_38 cs_height_lg_25" />

                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Phone number
                  </label>
                  {/* <input
                    placeholder="Type your phone number"
                    type="text"
                    className="cs_form_field"
                    style={{border:"1px solid #fd6219", borderRadius:"10px"}}
                  /> */}
                  <PhoneInput
                    country={"us"}
                    enableSearch={true}
                    value={phone}
                    onChange={(phone) => setPhone(phone)}
                    inputStyle={{
                      border: "1px solid #fd6219",
                      outline: "none",
                      width: "100%",
                      focus: "none"
                    }}
                  />
                  <div className="cs_height_38 cs_height_lg_25" />

                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Website
                  </label>
                  <input
                    placeholder="www.fleekcommerce.com"
                    type="text"
                    name="website"
                    required
                    className="cs_form_field"
                    style={{
                      border: "1px solid #fd6219",
                      borderRadius: "10px"
                    }}
                    onChange={handleChange}
                  />


<div className="cs_height_38 cs_height_lg_25" />

<label className="cs_fs_21 cs_semibold cs_primary_color">
  Budget
</label>
<input
  placeholder="$1000"
  type="text"
  name="budget"
  required
  className="cs_form_field"
  style={{
    border: "1px solid #fd6219",
    borderRadius: "10px"
  }}
  onChange={handleChange}
/>

                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Which services are you interested in?
                  </label>

                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div>
                        <input type="checkbox" name="service_data" value="✅"  onChange={handleChange}/>
                        <label
                          style={{ marginLeft: "10px", margitTop: "10px" }}
                        >
                          {" "}
                          Data Management
                        </label>
                      </div>

                      <div>
                        <input
                          type="checkbox"
                          name="service_software"
                          value="✅"
                          onChange={handleChange}
                        />
                        <label style={{ marginLeft: "10px" }}>
                          {" "}
                          Multichannel Softwares
                        </label>
                      </div>

                      <div>
                        <input
                          type="checkbox"
                          name="service_ads"
                          value="✅"
                          onChange={handleChange}
                        />
                        <label style={{ marginLeft: "10px" }}>
                          {" "}
                          Sponsored Ads
                        </label>
                      </div>

                      <div>
                        <input type="checkbox" name="service_digital" value="✅"  onChange={handleChange}/>
                        <label style={{ marginLeft: "10px" }}>
                          {" "}
                          Digital Marketing
                        </label>
                      </div>

                   

                      

                     
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div>
                        <input type="checkbox" name="service_website" value="✅"  onChange={handleChange}/>
                        <label
                          style={{ marginLeft: "10px", margitTop: "10px" }}
                        >
                          {" "}
                          Website Development
                        </label>
                      </div>

                      <div>
                        <input
                          type="checkbox"
                          name="service_graphics"
                          value="✅"
                          onChange={handleChange}
                        />
                        <label style={{ marginLeft: "10px" }}>
                          {" "}
                          Creative Graphics
                        </label>
                      </div>

                      <div>
                        <input type="checkbox" name="service_support" value="✅"  onChange={handleChange}/>
                        <label style={{ marginLeft: "10px" }}>
                          {" "}
                          Customer Support
                        </label>
                      </div>

                      <div>
                        <input
                          type="checkbox"
                          name="service_ebay"
                          value="✅"
                          onChange={handleChange}
                        />
                        <label style={{ marginLeft: "10px" }}>
                          {" "}
                          Ebay Template Generator
                        </label>
                      </div>

                    </div>
                  </div>

                  <div className="cs_height_38 cs_height_lg_25" />

                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Project brief
                  </label>
                  <textarea
                    cols={30}
                    rows={5}
                    name="message"
                    required
                    className="cs_form_field"
                    style={{
                      border: "1px solid #fd6219",
                      borderRadius: "10px"
                    }}
                    onChange={handleChange}
                  />

                  <div className="cs_height_38 cs_height_lg_25" />

                  <button className="cs_btn cs_style_1" type="submit">
                    Submit{" "}
                    <span>
                      <i>
                        <Icon icon="fa6-solid:arrow-right" />
                      </i>
                      <i>
                        <Icon icon="fa6-solid:arrow-right" />
                      </i>
                    </span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="cs_height_0 cs_height_lg_80" />
      </section>
      <div className="cs_map">
        <iframe
          id="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d673.3075842836843!2d90.41284090612989!3d23.812187695292224!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c7007a8a065b%3A0xc736bf6b1228538a!2sFleek%20Bangladesh!5e1!3m2!1sen!2sbd!4v1733251164194!5m2!1sen!2sbd"
          allowFullScreen
          title="Google Map"
        />
      </div>
    </>
  );
}
